import React from 'react'

import { ImagePreview } from '@components/common/ImagePreview'

import * as S from './styled'
import type { Props } from './types'

export const VariantImageCell = ({
  previewImage,
  showPreviewImage,
  imagesCount,
  isFirstOfGroup,
  isLastOfGroup,
}: Props) => (
  <S.Container>
    {showPreviewImage && (
      <S.ImageContainer isLast={isLastOfGroup}>
        {isFirstOfGroup && (
          <>
            {!isLastOfGroup && <S.FirstImageLine />}
            <ImagePreview image={previewImage} imagesCount={imagesCount} />
          </>
        )}
        {!isFirstOfGroup && !isLastOfGroup && <S.ConsecutiveImageLine />}
        {!isFirstOfGroup && isLastOfGroup && <S.LastImageLine />}
      </S.ImageContainer>
    )}
  </S.Container>
)
